import { createActions } from '../utils/actions';

const { actions: selectPhotos } = createActions('selectPhotos')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('getFolders')
  .addAsync('getImages')
  .add('setValue')
  .add('toggleImageState');

export default selectPhotos;
